import axios from "axios";
import * as Constants from "../constant";
const deleteUser = async (email) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/userauth/IsDesible/${email}`
		);
		return response.status === 200 ? true : false;
	} catch (error) {
		return error.response.status;
	}
};
export default deleteUser;
